enum GatewayStatusConstants {
  UNDEFINED = 'UNDEFINED',
  ERROR = 'ERROR',
  WARN = 'WARN',
  OK = 'OK',
}

export default GatewayStatusConstants;
